// Angular
import { Component, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';

// Afidium
import { WORDING } from "../config/wording";
import { ICONS } from 'app_sasha/shared/components/processing-status/processing-status.component';
import { ITask, TaskStatus } from 'libraries/service/resources/booking-task-resource/ITask';
import { PROCESSING_STATUSES } from 'app_sasha/shared/wordings/processing';
import { ILabels } from 'libraries/interfaces/ILabels';
import { IconDefinition } from "@fortawesome/free-regular-svg-icons";

@Component({
    selector: 'processing-task-status',
    template: `
    <div class="container">
        <div class="status" [ngClass]="task.status">
            <div class="round" [title]="statuses[task.status]">
                <fa-icon [icon]="icons[task.status]"></fa-icon>
            </div>
            <div class="status-text sep-right"><strong> {{statuses[task.status]}}</strong></div>
            <ng-container *ngIf="canRetry">
                <btn permissionShow="sasha.processing.email.use"
                     [label]="wording.retry"
                     type="actionDo"
                     (click)="onClickOnRetry.emit(task)"></btn>
            </ng-container>
        </div>
        <p class="message" *ngIf="task.message">{{task.message}}</p>
    </div>
    `,
    styles: [`
    .container{
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .status{
        display: flex;
        flex-wrap: wrap;
    }

    btn{
        flex: 0 0 auto;
    }

    .message{
        margin-top: 15px;
    }

    .round{
        flex: 0 0 auto;
        border-radius: 100%;
        text-align: center;
        width: 2em;
        height: 2em;
        line-height: 2em;
        margin-right: 15px;
        color: white;
    }

    .status-text{
        flex: 1;
    }

    .round,
    .status-text {
        align-self : center;
    }

    .success .round {
        background: #3c763d;
    }

    .success .status-text{
        color: #3c763d;
    }

    .warning .round {
        background: #8a6d3b;
    }

    .warning .status-text{
        color: #8a6d3b;
    }

    .pending .round{
        background: #4f5f6f;
    }

    .pending .status-text{
        color: #4f5f6f;
    }

    .error .round{
        background: #a94442;
    }

    .error .status-text{
        color: #a94442;
    }

    .processing .round{
        background: #505050;
    }

    .processing .status-text{
        color: #505050;
    }
    `],
})
export class ProcessingTaskStatusComponent implements OnChanges {
    @Input()
    public task: ITask;

    @Output()
    public readonly onClickOnRetry: EventEmitter<ITask> = new EventEmitter();

    public wording: ILabels = WORDING;
    public icons: { [key: string]: IconDefinition } = ICONS;
    public statuses: ILabels = PROCESSING_STATUSES;
    public canRetry: boolean = false;

    public ngOnChanges(changes: SimpleChanges): void {
        this.canRetry = this.task && (this.task.status === TaskStatus.Error || this.task.status === TaskStatus.Warning);
    }
}
